import { defineComponent as _defineComponent } from 'vue'
import { useDeviceStore } from "@/stores/deviceStore";
import DOMPurify from "dompurify";
import { ref, watch } from "vue";


const __default__ = {
  name: "BaseTextarea",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
  },
  value: {
    type: String,
    default: "",
  },
  cols: {
    type: Number,
    default: 30,
  },
  rows: {
    type: Number,
    default: 6,
  },
  maxlength: {
    type: Number,
  },
  placeholder: {
    type: String,
  },
  getTextAreaLength: {
    type: Number,
  },
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: true,
  },
},
  emits: ["onInput", "onFocus"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const deviceStore = useDeviceStore();
const textareaRef = ref<HTMLTextAreaElement>();
const focusingElement = ref<HTMLInputElement>();

const onInput = (event: Event) => {
  const textareaElement = event.target as HTMLTextAreaElement;
  const sanitizedValue = DOMPurify.sanitize(textareaElement.value);
  textareaElement.value = sanitizedValue;
  emit("onInput", sanitizedValue);
};

const onFocus = (event: Event) => {
  focusingElement.value = event.target as HTMLInputElement;
  emit("onFocus");
};

const onBlurred = () => {
  focusingElement.value = undefined;
};

watch(
  () => deviceStore.isShowingKeyboard,
  async (isShowing, _) => {
    if (!isShowing) return;

    focusingElement.value?.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  }
);

const __returned__ = { emit, deviceStore, textareaRef, focusingElement, onInput, onFocus, onBlurred }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})